import React from "react";
import Sec1 from "./Sec1/Sec1";
import Sec2 from "./Sec2/Sec2";
import Sec3 from "./Sec3/Sec3";
import Sec4 from "./Sec4/Sec4";
import Sec5 from "./Sec5/Sec5";
import LogoSlider from "./LogoSlider/LogoSlider";
import Sec6 from "./Sec6/Sec6";
import "./Home.css";
import { Helmet } from "react-helmet";

function Home(params) {
  return (
    <div>
      <Helmet>
        <title>Creative Balloons, All Inflatables | Creative Balloons</title>
        <meta
          name="description"
          content="Sky balloon, Inflatables, Costumes, Bouncy Castles, Arches, Danglers, templets"
        />
      </Helmet>
      <div className="Home" id="HOME">
        <Sec1 />
        <Sec3 />
        <Sec4 />
        <Sec5 />
        <LogoSlider />
        <Sec2 />
        <Sec6 />
      </div>
    </div>
  );
}

export default Home;
